import React from "react";
import BarLoader from "react-spinners/BarLoader";

const LoadingMore = show => (
  <div className="loading-more">
    <BarLoader color={"#FF543E"} loading={show}/>
  </div>
)

export default LoadingMore;